module.exports = __webpack_public_path__ + "images/illustration-map-pin-0395fdcc3c91afd63f665f50bec07404.png";